import Header from "../Home/header";
import Footer from "../Home/footer";
import React, { useState } from "react";
import logo from "../media/logo.png";
import "./contactus.css";
const Contactus = () => {
  const [email, setemail] = useState();
  const [phone, setphone] = useState();
  const [name, setname] = useState();
  const [message, setmessage] = useState();
  const [showPop, setshowPop] = useState(false);

  const host = process.env.REACT_APP_HOST;
  const handlesubmit = () => {
    var raw = JSON.stringify({
      id_user: 1,
      email: email,
      fullname: name,
      phone: phone,
      message: message,
    });
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${host}/NewMessage`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));

    setshowPop(true);
  };

  return (
    <>
      <Header />

      <div className={showPop ? "containercont blur-in " : "containercont"}>
        <div id="contact">
          <h3>Quick Contact</h3>
          <h4>Contact us today, and get reply with in 24 hours!</h4>
          <fieldset>
            <input
              value={name}
              onChange={(e) => {
                setname(e.target.value);
              }}
              placeholder="Your name"
              type="text"
              tabindex="1"
              required
              autofocus
            />
          </fieldset>
          <fieldset>
            <input
              value={email}
              onChange={(e) => {
                setemail(e.target.value);
              }}
              placeholder="Your Email Address"
              type="email"
              tabindex="2"
              required
            />
          </fieldset>
          <fieldset>
            <input
              value={phone}
              onChange={(e) => {
                setphone(e.target.value);
              }}
              placeholder="Your Phone Number"
              type="tel"
              tabindex="3"
              required
            />
          </fieldset>

          <fieldset>
            <textarea
              value={message}
              onChange={(e) => {
                setmessage(e.target.value);
              }}
              placeholder="Type your Message Here...."
              tabindex="5"
              required
            ></textarea>
          </fieldset>
          <fieldset>
            <button
              onClick={handlesubmit}
              name="submit"
              type="submit"
              id="contact-submit"
              data-submit="...Sending"
            >
              Submit
            </button>
          </fieldset>
        </div>
      </div>

      {showPop && (
        <div class="row pop-up">
          <div className="allco">
            <div className="tith3">
              <h3> Thank you for contacting us </h3>
            </div>
            <div className="thankyoumsg">
              <p>
                We wanted to take a moment to express our gratitude for you
                reaching out to us. Thank you for contacting us and giving us
                the opportunity to assist you. Our team will reply to you within
                12 hours.
                <br />
              </p>
            </div>

            <div className="bestre">
              <strong>Best regards ❤️</strong>
            </div>

            <div className="cancelbot">
              <button
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Contactus;
